import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PageContent } from '../../shared/page-content/page-content.component';

@Component({
  selector: 'app-not-found',
  imports: [RouterLink, PageContent],
  templateUrl: './not-found.component.html',
})
export class NotFound {}
